// api/config.js
// URLやらの設定をここに記述し，他のapi実装モジュールから読み込む
import axios from 'axios'
import HOST from './hosts'
// リクエストの基本設定を記述する
let api = axios.create({
  'baseURL': HOST
})
api.interceptors.request.use((config) => {
  config.headers = Object.assign(config.headers, {
    'Authorization': 'Bearer ' + localStorage.getItem('token')
  })
  return config
})
export default api



// WEBPACK FOOTER //
// ./src/api/api_base.js